import { KnmHistoryOperationsEnum } from 'APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';

import { RenderFunc } from '../types/RenderFunc';

export const renderSubjectId: RenderFunc = item => {
  const { operation, newValue, oldValue } = item;
  let newValueText = typeof newValue === 'string' ? newValue : '';

  if (operation === KnmHistoryOperationsEnum.INSERT) {
    const splitField = item.field.split('/');

    newValueText = `${splitField[splitField.length - 1]} ${newValue}`;
  }

  return {
    renderedOldValue: typeof oldValue === 'string' ? oldValue : '',
    renderedNewValue: newValueText,
  };
};
